import React, { SyntheticEvent } from 'react';
import Input from '../../../components/Input';
import BankCodeDropdown from '../../../components/BankCodeDropdown';
import Dropdown from '../../../components/Dropdown';
import SectionLabel from '../../../components/SectionLabel';
import { Checkbox, Grid } from 'semantic-ui-react';
import { Field } from 'formik';
import { FormikErrorMessage } from '../../../components/ErrorMessage';
import { FieldLabel } from '../../../styles';
import { formatPercentageValue, isPercentageAboveMaximum, maskPercentageValue } from '../../../utils/percentage';
import { dangerNotification } from '../../../services/notification';
import { EstateFormProps } from '../UpdateEstateForm';

export const BankAccountData = (props: EstateFormProps) => {
  const { errors, touched, handleInputChange, setFieldValue, values } = props;

  const handleCommissionPercentBlur = () => {
    if (isPercentageAboveMaximum(values.standaloneChargesCommissionPercent)) {
      dangerNotification(
        'Percentual Repassado',
        'O percentual repassado não pode ser maior que 100,00.'
      );
      return;
    }

    setFieldValue(
      'standaloneChargesCommissionPercent',
      formatPercentageValue(values.standaloneChargesCommissionPercent)
    );
  };
  const pixKeyTypeOptions = [
    { key: 'CPF', text: 'CPF', value: 'CPF' },
    { key: 'CNPJ', text: 'CNPJ', value: 'CNPJ' },
    { key: 'EMAIL', text: 'E-mail', value: 'EMAIL' },
    { key: 'PHONE', text: 'Telefone', value: 'PHONE' },
    { key: 'EVP', text: 'Chave Aleatória', value: 'EVP' }
  ];
  return (
    <>
      <SectionLabel text="DADOS BANCÁRIOS" />

      <Grid.Row>
        <Grid.Column width={6}>
          <FieldLabel>Banco*</FieldLabel>
          <Field
            name="bankAccount.bankCode"
            className={
              errors && errors.bankAccount && touched && touched.bankAccount
                ? 'text-input error'
                : 'text-input'
            }
            onChange={(e: SyntheticEvent, data: any) => handleInputChange(data, props)}
            component={BankCodeDropdown}
            maxLength={3}
            fluid
          />
          <FormikErrorMessage component="div" name="bankAccount.bankCode" />
        </Grid.Column>

        <Grid.Column width={4}>
          <FieldLabel>Agência*</FieldLabel>
          <Field
            name="bankAccount.agencyNumber"
            className={
              errors && errors.bankAccount && touched && touched.bankAccount
                ? 'text-input error'
                : 'text-input'
            }
            onChange={(e: SyntheticEvent, data: any) => handleInputChange(data, props)}
            component={Input}
            maxLength={4}
            fluid
          />
          <FormikErrorMessage component="div" name="bankAccount.agencyNumber" />
        </Grid.Column>

        <Grid.Column width={1} style={{ padding: 1 }}>
          <Field
            name="bankAccount.agencyDv"
            style={{ marginTop: '18px' }}
            className={
              errors && errors.bankAccount && touched && touched.bankAccount
                ? 'text-input error'
                : 'text-input'
            }
            onChange={(e: SyntheticEvent, data: any) => handleInputChange(data, props)}
            component={Input}
            maxLength={1}
            fluid
          />
          <FormikErrorMessage component="div" name="bankAccount.agencyDv" />
        </Grid.Column>

        <Grid.Column width={4}>
          <FieldLabel>Conta*</FieldLabel>
          <Field
            name="bankAccount.accountNumber"
            className={
              errors && errors.bankAccount && touched && touched.bankAccount
                ? 'text-input error'
                : 'text-input'
            }
            onChange={(e: SyntheticEvent, data: any) => handleInputChange(data, props)}
            component={Input}
            fluid
          />
          <FormikErrorMessage component="div" name="bankAccount.accountNumber" />
        </Grid.Column>

        <Grid.Column width={1} style={{ padding: 3 }}>
          <Field
            name="bankAccount.accountDv"
            style={{ marginTop: '18px' }}
            className={
              errors && errors.bankAccount && touched && touched.bankAccount
                ? 'text-input error'
                : 'text-input'
            }
            onChange={(e: SyntheticEvent, data: any) => handleInputChange(data, props)}
            component={Input}
            maxLength={1}
            fluid
          />
          <FormikErrorMessage component="div" name="bankAccount.accountDv" />
        </Grid.Column>
      </Grid.Row>

      <SectionLabel text="INFORMAÇÕES DE COBRANÇA" />
      <Grid.Row>
        <Grid.Column width={16}>
          <FieldLabel>
            {values.standaloneChargesEnabled
              ? 'Cobrança Avulsa Ativada'
              : 'Cobrança Avulsa Desativada'}
          </FieldLabel>
          <Checkbox
            toggle
            checked={Boolean(values.standaloneChargesEnabled)}
            label="Permitir que esta imobiliária acesse o menu de Cobranças"
            onChange={(_, data) =>
              setFieldValue('standaloneChargesEnabled', Boolean(data.checked))
            }
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={6}>
          <FieldLabel>Tipo da chave</FieldLabel>
          <Field
            name="bankAccount.pixKeyType"
            component={Dropdown}
            options={pixKeyTypeOptions}
            clearable
            search
            selection
            className={
              errors && errors.bankAccount && touched && touched.bankAccount
                ? 'text-input error'
                : 'text-input'
            }
            onChange={(e: SyntheticEvent, data: any) => handleInputChange(data, props)}
            fluid
          />
          <FormikErrorMessage component="div" name="bankAccount.pixKeyType" />
        </Grid.Column>

        <Grid.Column width={10}>
          <FieldLabel>Chave Pix</FieldLabel>
          <Field
            name="bankAccount.pixKey"
            className={
              errors && errors.bankAccount && touched && touched.bankAccount
                ? 'text-input error'
                : 'text-input'
            }
            onChange={(e: SyntheticEvent, data: any) => handleInputChange(data, props)}
            component={Input}
            fluid
          />
          <FormikErrorMessage component="div" name="bankAccount.pixKey" />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={16}>
          <FieldLabel>Taxa de cobrança (%)</FieldLabel>
          <Field
            name="bankAccount.standaloneChargesSplitPercent"
            className={
              errors && errors.bankAccount && touched && touched.bankAccount
                ? 'text-input error'
                : 'text-input'
            }
            onChange={(e: SyntheticEvent, data: any) => handleInputChange(data, props)}
            component={Input}
            type="number"
            min={0}
            max={100}
            step={0.01}
            fluid
          />
          <p style={{ margin: '6px 0 0', fontSize: '0.85em', color: '#666' }}>
            Percentual retido pela corretora sobre cada cobrança avulsa; o restante fica
            para a imobiliária.
          </p>
          <FormikErrorMessage
            component="div"
            name="bankAccount.standaloneChargesSplitPercent"
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={4}>
          <FieldLabel>Habilitar comissionamento</FieldLabel>
          <Checkbox
            toggle
            checked={Boolean(values.standaloneChargesCommissionEnabled)}
            onChange={(_, data) =>
              setFieldValue('standaloneChargesCommissionEnabled', Boolean(data.checked))
            }
          />
        </Grid.Column>

        <Grid.Column width={5}>
          <FieldLabel>Percentual Repassado(%)</FieldLabel>
          <Field
            name="standaloneChargesCommissionPercent"
            className={
              errors && errors.bankAccount && touched && touched.bankAccount
                ? 'text-input error'
                : 'text-input'
            }
            onChange={(_: SyntheticEvent, data: any) =>
              setFieldValue('standaloneChargesCommissionPercent', maskPercentageValue(data.value))
            }
            onBlur={handleCommissionPercentBlur}
            component={Input}
            inputMode="decimal"
            fluid
          />
          <p style={{ margin: '6px 0 0', fontSize: '0.85em', color: '#666' }}>
            *O percentual comissionado será aplicado para todos os colaboradores válidos.
          </p>
          <FormikErrorMessage component="div" name="standaloneChargesCommissionPercent" />
        </Grid.Column>
      </Grid.Row>
    </>
  );
};
